import * as modules from '@scripts/modules';
import { Logger } from '@scripts/mixins';

let resolvePromise = null;

/**
 * Resolves with the instance lookup once all modules are initialized.
 * @type {Promise<Object<string, Map<Element, Object>>>}
 */
export const modulesLoaded = new Promise((resolve) => (resolvePromise = resolve));

export let instanceLookup = {};
export const updateInstances = (module, instance) => {
	if (!instanceLookup[module]) {
		instanceLookup[module] = new Map();
	}

	if (instance.elNode) {
		instanceLookup[module].set(instance.elNode, instance);
	}
};

/**
 * Initialize all registered modules and build the instance lookup.
 * @returns {Promise<Array<{key: string, instances: Object[]}>>}
 */
export const loadModules = () => {
	let promises = Object.entries(modules).map(([key, factory]) => {
		return new Promise((resolve, reject) => {
			const instances = factory();

			resolve({
				key,
				instances
			});
		});
	});

	return Promise.all(promises).then((entries) => {
		instanceLookup = entries
			.filter((entry) => entry?.instances?.filter?.(Boolean).length)
			.reduce((prev, entry) => {
				prev[entry.key] = new Map();

				entry.instances.forEach((instance) => {
					const node = instance.elNode || instance.node;
					if (!node) return;

					prev[entry.key].set(node, instance);
				});

				return prev;
			}, {});

		Object.defineProperty(instanceLookup, 'getModule', {
			value: (name) => {
				if (!Object.keys(instanceLookup).includes(name)) {
					Logger.error(`Module ${name} does not exist or does have any instances.`);
					return null;
				} else {
					return instanceLookup[name];
				}
			}
		});

		resolvePromise(instanceLookup);

		return entries;
	}).catch((error) => {
		Logger.error(error);
	});
};
